var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegetativeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    viewBox: "0 0 6 104",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.1875L5.88675 -0.8125L0.113249 -0.8125L2.5 4.1875L3.5 4.1875ZM2.5 3.6875L2.50001 136.188L3.50001 136.187L3.5 3.6875L2.5 3.6875Z",
    fill: "#19A04B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetativeIcon);
export default __webpack_public_path__ + "static/media/vegetative_icon.46bbcde6c7ecd35b939c988dcc29fffa.svg";
export { ForwardRef as ReactComponent };